module.exports = "/assets/dist/images/bodystyles_coupes_sm.png?87d2ce60eaa50c9ce333d043d90f85b6";